import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import SearchBar from "../../../../app/common/form/SearchBar.tsx";
import "./styles.css";
import { useStore } from "../../../../app/stores/store.ts";
import { observer } from "mobx-react-lite";

const TaxFilters: React.FC = () => {
  const { taxStore } = useStore();

  const {
    nameFilter,
    isActiveFilter,
    setNameFilter,
    setIsActiveFilter,
    setPagingParams,
    loadTaxes,
  } = taxStore;

  const loadFilteredTaxes = () => {
    setPagingParams({
      pageNumber: 1,
      pageSize: taxStore.pagingParams.pageSize,
    });
    loadTaxes();
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameFilter(event.target.value);
    loadFilteredTaxes();
  };

  const handleIsActiveChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsActiveFilter(event.target.checked);
    loadFilteredTaxes();
  };

  return (
    <div>
      <div className="tax-filters">
        <SearchBar
          label="Search by name"
          value={nameFilter}
          onChange={handleNameChange}
          className="search-bar"
        />
        <FormControlLabel
          control={
            <Switch checked={isActiveFilter} onChange={handleIsActiveChange} />
          }
          label="Active"
        />
      </div>
    </div>
  );
};

export default observer(TaxFilters);